import { CSSProperties, ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

/**
 * Plain wrapper — no entry animation. The previous framer-motion fade
 * caused initial opacity:0 on the entire page, which blocked LCP because
 * the preloaded hero image was invisible until hydration completed.
 * Per-section motion is preserved inside individual pages.
 */
export function PageContainer({ children, className = '', style }: PageContainerProps) {
  return (
    <div className={`app-page ${className}`} style={style}>
      {children}
    </div>
  );
}
